import './Overlay.scss';

import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';

const Overlay = ({ isOpen, onClick }) => {
	return (
		<div
			data-testid="siteSearch-overlay"
			aria-hidden="true"
			onClick={onClick}
			className={cx(
				'siteSearch__overlay',
				'bg-gray-100',
				'bottom-0',
				'fixed',
				'left-0',
				'right-0',
				'top-0',
				'z-40',
				isOpen
					? 'pointer-events-auto opacity-75'
					: 'pointer-events-none opacity-0'
			)}></div>
	);
};

Overlay.propTypes = {
	isOpen: PropTypes.bool,
	onClick: PropTypes.func,
};

export default Overlay;
